import ComposeViewState from '../store/schema/ComposeViewState';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * This util will return
 * True - if the compose is a S/MIME message, False - otherwise
 */
export default function isSmimeEnabledInViewState(viewState: ComposeViewState): boolean {
    if (viewState.smimeViewState) {
        const { shouldEncryptMessageAsSmime, shouldSignMessageAsSmime } = viewState.smimeViewState;
        return (
            isFeatureEnabled('cmp-smime') &&
            (shouldEncryptMessageAsSmime || shouldSignMessageAsSmime)
        );
    } else {
        return false;
    }
}
